import React from 'react'
import { utils } from 'alelo-logic'
import { renderTextInput, renderSelectField } from 'utils/renderInputs'
import { Field } from 'redux-form'

import { labels } from './data.json'

const AxisField = ({ axis }) => (
  <Field
    placeholder=" "
    component={renderSelectField}
    label={labels.axis}
    name="axis"
    options={axis}
    validate={utils.emptyFieldValidate}
  />
)

const PlateField = () => (
  <Field
    component={renderTextInput}
    label={labels.plate}
    name="plate"
    type="text"
    validate={utils.plateValidate}
    normalize={utils.plateMask}
    isRequired
    autoComplete="off"
    tooltip="O preenchimento deve seguir o padrão atual ABC1234 ou padrão placa Mercosul ABC1D23"
  />
)

const IdentifierField = () => (
  <Field
    component={renderTextInput}
    label={labels.identifier}
    name="identifier"
    type="text"
    validate={utils.identifierValidate}
    isRequired
  />
)

export { AxisField, PlateField, IdentifierField }



// WEBPACK FOOTER //
// ./src/app/pages/Activation/form-fields.js